import React, { useEffect } from "react";
import styles from "./OccasionPage.module.css";
import useOccasionStore from "../../Stores/useOccasionStore";
import NewPolaroid from "../../Components/Products/NewPolaroid";
import OccasionCard from "../../Components/Occasions/OccasionCard";
import { Link } from "react-router-dom";
import OccasionsCarousel from "../../Components/Occasions/Carousel/OccasionsCarousel";
import useWindowWidth from "../../Hooks/useWindowWidth";

function OccasionPage() {
  const { occasions, getOccasions, loading, errors } = useOccasionStore();
  const [selectedImageIndex, setSelectedImageIndex] = React.useState(0);
  const windowWidth = useWindowWidth();
  useEffect(() => {
    const fetchOccasions = async () => {
      await getOccasions();
    };
    fetchOccasions();
  }, [getOccasions]);

  return (
    <div className={styles.OccasionPage}>
      <div className={styles.Title}>Occasions</div>
      <div className={styles.HeaderInfo}>
        <div className={styles.HeaderText}>Hampers for Every  Occasion</div>
        <div className={styles.HeaderSubText}>
          Discover beautifully curated hampers for life’s special moments:
          birthdays, weddings, new arrivals, new homes, and more. Each hamper is
          thoughtfully wrapped, with personalisation included, and free
          island-wide delivery across Jersey.
        </div>
      </div>      
      {loading && <div>Loading occasions...</div>}
      {errors.length > 0 && (
        <div className={styles.ErrorMessages}>
          An error occurred while fetching occasions.
        </div>
      )}
      {!loading && occasions.length === 0 && <div>No occasions available.</div>}
      {!loading && occasions.length > 0 ? (
        windowWidth >= 500 ? (
          <div className={styles.OccasionGrid}>
            {occasions.map((occasion) => (
              <OccasionCard
                key={occasion.Id}
                Id={occasion.Id}
                FriendlyName={occasion.FriendlyName}
                Name={occasion.Name}
                Image={occasion.Image}
                Theme={occasion.Theme}
                description={occasion.Description}
              />
            ))}
          </div>
        ) : (
          <div className={styles.CarouselContainer}>
            <OccasionsCarousel occasions={occasions} />
          </div>
        )
      ) : null}

      <div className={styles.HereToHelp}>
        <div className={styles.HereToHelpTitle}>We’re here to help!</div>
        <div className={styles.HereToHelpText}>
          <Link to="/Customer-Services/Contact">Contact us</Link> to discuss
          ideas for your next occasion in Jersey.
        </div>
      </div>
    </div>
  );
}

export default OccasionPage;
